import type { ProductDetail } from "@/api/productDetailTypes";
import { APIClient } from "@/api/client";

export const getProductDetail = async (
  productId: number,
  limitedProductId?: number,
  options?: { language?: string },
) => {
  const { data } = await APIClient.AppProduct.getProductDetail(
    "",
    productId,
    limitedProductId,
    options?.language
      ? {
          headers: {
            "Accept-Language": options.language,
          },
        }
      : undefined,
  );

  return data as ProductDetail;
};
